(function () {

    angular
        .module('invesfleet')
        .run(run);

    run.$inject = [
        '$rootScope',
        '$state',
        '$uiRouter',
        '$q',
        '$urlRouter',
        '$transitions',
        '$templateCache',
        'ModalService',
        'audioService',
        'authorization',
        '$timeout',
        'preferences',
        'runtimeStates',
        'common',
        'messagingService', 
        'restrictionService', 
        '$location'
    ];

    /* jshint maxstatements:false */
    /* jshint maxparams:false */
    function run(
        $rootScope,
        $state,
        $uiRouter,
        $q,
        $urlRouter,
        $transitions,
        $templateCache,
        ModalService,
        audioService,
        authorization,
        $timeout,
        preferences,
        runtimeStates,
        common,
        messagingService, 
        restrictionService, 
        $location
    ) {
        //Silent sound so that sounds keep playing in the background later
        try {
            audioService.play('content/sounds/silence.mp3');
        } catch (e) {
            console.error(e);
        }
        
        Date.NewDate = function () {
            var now = new Date();
            var utcOffset = now.getTimezoneOffset();
            var minuteOffset = preferences.prefs.companyPrefs.minuteOffset;
            return new Date(now.getTime() + utcOffset * 60 * 1000 + minuteOffset * 60 * 1000);
        };

        $rootScope.$state = $state;

        $rootScope.restrictionService = restrictionService;

        $rootScope.sidebarOpen = true;

        $rootScope.stateStorage = {};

        $rootScope.tabManager = {
            tabs: [],
            prevSelectedTab: null,
            selectedTab: null,
            hideTimer: null,
            isVisible: false,
            show: function () {
                $timeout.cancel($rootScope.tabManager.hideTimer);
                $rootScope.tabManager.isVisible = true;
            },
            hide: function () {
                $rootScope.tabManager.hideTimer = $timeout(function () {
                    $rootScope.tabManager.isVisible = false;
                }, 500);
            },
            add: function (title, viewName, hostedState, icon, fixed, params, parent, sidebar) {
                var newTab = {
                    title: title,
                    updateTitle: true,
                    name: viewName,
                    state: hostedState,
                    icon: icon,
                    fixed: fixed,
                    params: params,
                    parent: parent,
                    sidebar: sidebar,
                    isDirty: false,
                };

                newTab.isActive = function () { return this.name === $rootScope.tabManager.selectedTab.name; };

                $rootScope.tabManager.tabs.push(newTab);

                return newTab;
            },
            goToOrdenes: function (id, programada) {

                var entityName = 'ordenes';
                var params = { 'id': id };
                var tabView;
                var uiView;
                var stateName;

                if (!common.isNullOrUndefined(id)) {
                    tabView = entityName + '-' + id;
                    uiView = entityName + '-ui-view-' + id;
                    stateName = 'flota.' + tabView + '.editar';
                } else {
                    var guid = common.uuidv4();
                    tabView = entityName + '-new-' + guid;
                    uiView = entityName + '-ui-view-new-' + guid;
                    stateName = 'flota.' + tabView + '.nueva';
                }

                var states = $state.get().map(function (state) {
                    return state.name;
                });
                for (var i = 0; i < states.length; i++) {
                    if (stateName === states[i]) {
                        $state.go(stateName, params);
                        return;
                    }
                }

                var parentState = {
                    url: '/' + entityName,
                    abstract: true,
                    sticky: true,
                    views: {}
                };
                parentState.views[tabView] = {
                    template: '<div ui-view="' + uiView + '"/>'
                };
                runtimeStates.addState('flota.' + tabView, parentState);

                if (!common.isNullOrUndefined(id)) {
                    state = {
                        url: '/editar?id',
                        data: { tabTitle: 'Editar orden', tabView: tabView, icon: 'icon-012', refreshAfterSave: ['flota.ordenes.listado', 'flota.OrdenesActivas'] },
                        params: { allOrdersOpen: null, accion: 'guardarCerrar', 'programada': programada },
                        views: { }
                    };
                } else {
                    var tabTitle;
                    switch (preferences.prefs.sector) {
                        case 'TAX':
                            tabTitle = (programada === true) ? 'Reserva' : 'Orden';
                            break;
                        case 'GRU':                            
                        default:
                            tabTitle = (programada === true) ? 'Programada' : 'Orden';
                    }

                    state = {
                        url: '/nueva',
                        data: { tabTitle: 'Nueva ' + tabTitle, tabView: tabView, icon: 'icon-012', refreshAfterSave: ['flota.ordenes.listado', 'flota.OrdenesActivas'] },
                        params: { accion: 'guardarCerrar', preload: null, 'programada': programada },
                        views: { }
                    };
                }

                var templateUrl;
                switch (preferences.prefs.sector) {
                    case 'TAX':
                        templateUrl = 'app/views/flota/ordenes/form_ordenTAX.html';
                        break;
                    case 'GRU':
                    default:
                        templateUrl = 'app/views/flota/ordenes/form_ordenGRU.html';
                }

                state.views[uiView] = {
                    controller: 'OrderFormController',
                    controllerAs: 'vm',
                    templateUrl: templateUrl,
                };
                runtimeStates.addState(stateName, state);

                $state.go(stateName, params);
            },
            removeByStateName: function (stateName) {
                var ix = $rootScope.tabManager.indexOfState(stateName);
                if (ix >= 0) {
                    var tab = $rootScope.tabManager.tabs[ix];
                    if (tab.fixed) { return; }
                    
                    if (tab.modified) {
                        tab.closeAction = function () {
                            $rootScope.tabManager.remove(tab);
                        };
                        $rootScope.$broadcast('checkExitAction' + tab.state);
                        return;
                    }
                    
                    var removed = $rootScope.tabManager.tabs.splice(ix, 1)[0];
                }
            },
            remove: function (tab) {
                if (tab.fixed) { return; }
                if (tab.isActive()) { $rootScope.tabManager.removeActiveTab(); return; }
                if (tab.modified) {
                    tab.closeAction = function () {
                        $rootScope.tabManager.remove(tab);
                    };
                    $rootScope.$broadcast('checkExitAction' + tab.state);
                    return;
                }

                if ($rootScope.tabManager.tabs.length > 1) {
                    var index = $rootScope.tabManager.tabs.indexOf(tab);
                    var removed = $rootScope.tabManager.tabs.splice(index, 1)[0];
                    //$stickyState.reset(removed.state);
                }
            },

            removeActiveTab: function (scope) {
                if ($rootScope.tabManager.tabs.length > 1) {
                    var activeTab = null;
                    for (var i = 0, len = $rootScope.tabManager.tabs.length; i < len; i++) {
                        if ($rootScope.tabManager.tabs[i].isActive()) {
                            activeTab = $rootScope.tabManager.tabs[i];
                        }
                    }
                    if (activeTab.fixed) {
                        return;
                    }

                    if (activeTab.modified) {
                        activeTab.closeAction = function () {
                            $rootScope.tabManager.remove(activeTab);
                        };
                        $rootScope.$broadcast('checkExitAction' + activeTab.state);
                        return;
                    }

                    var index = $rootScope.tabManager.tabs.indexOf(activeTab);
                    var removed = $rootScope.tabManager.tabs.splice(index, 1)[0];

                    var newActive = null;
                    if (
                        $rootScope.tabManager.prevSelectedTab !== null &&
                        $rootScope.tabManager.prevSelectedTab.name !== removed.name
                    ) {
                        newActive = $rootScope.tabManager.prevSelectedTab;
                    }

                    if (newActive === null) {
                        var newActiveIndex = removed.parent ? $rootScope.tabManager.indexOfState(removed.parent.name) : 0;
                        newActiveIndex = newActiveIndex >= 0 ? newActiveIndex : 0;
                        newActive = $rootScope.tabManager.tabs[newActiveIndex];
                    }

                    $rootScope.tabManager.activate(newActive.title,
                        newActive.name,
                        newActive.state,
                        newActive.icon,
                        newActive.fixed,
                        newActive.params);

                    //$stickyState.reset(removed.state);                    
                    $rootScope.stateSelect(newActive);
                }
            },

            indexOfName: function (stateName) {
                for (var i = 0, len = $rootScope.tabManager.tabs.length; i < len; i++) {
                    if ($rootScope.tabManager.tabs[i].name === stateName) {
                        return i;
                    }
                }
                return -1;
            },

            indexOfState: function (stateName) {
                for (var i = 0, len = $rootScope.tabManager.tabs.length; i < len; i++) {
                    if ($rootScope.tabManager.tabs[i].state === stateName) {
                        return i;
                    }
                }
                return -1;
            },

            activate: function (title, viewName, hostedState, icon, fixed, params, parent, sidebar) {
                var index = $rootScope.tabManager.indexOfName(viewName);
                var tab = null;
                var ret;
                if (index > -1) {
                    tab = $rootScope.tabManager.tabs[index];
                    if (tab.updateTitle)
                        tab.title = title;
                    tab.icon = icon;
                    tab.fixed = fixed;
                    tab.state = hostedState;
                    tab.params = params;
                    tab.keepState = true;
                    if ($rootScope.tabManager.prevSelectedTab === null || $rootScope.tabManager.prevSelectedTab.name !== $rootScope.tabManager.selectedTab.name)
                        $rootScope.tabManager.prevSelectedTab = $rootScope.tabManager.selectedTab;
                    ret = true;
                }
                else
                {
                    tab = $rootScope.tabManager.add(title,
                        viewName,
                        hostedState,
                        icon,
                        fixed,
                        params,
                        parent,
                        sidebar);
                    if ($rootScope.tabManager.prevSelectedTab === null || $rootScope.tabManager.prevSelectedTab.name != $rootScope.tabManager.selectedTab.name)
                        $rootScope.tabManager.prevSelectedTab = $rootScope.tabManager.selectedTab;
                    ret = false;
                }

                $rootScope.tabManager.selectedTab = tab;
                $rootScope.sidebarOpen = tab.sidebar;

                return ret;
            },

            goToTab: function(tab) {
                if (tab.isActive()) {
                    return;
                }

                $state.go(tab.state, tab.params);
            },

        };

        $rootScope.searchManager = {
            searchText: '',
            inputIsVisible: false,
            onSearch: function () {                
                $state.go('flota.search.results', {
                    q: $rootScope.searchManager.searchText
                });
            },
            onClear: function () {
            },
            onInputLostFocus: function (id) {
                //var i = document.getElementById(id);
                //i.value = '';
                //$rootScope.searchManager.inputIsVisible = false;
            },
            openSearchResultTab: function (searchTabsAccum, uiView, tabView, tabTitle, params) {

                var parentState = {
                    url: '/' + tabView,
                    abstract: true,
                    sticky: true,
                    views: {}
                };
                parentState.views[tabView] = {
                    template: '<div ui-view="' + uiView + '"/>'
                };
                runtimeStates.addState('flota.' + tabView, parentState);

                var state = {
                    url: '/results?q',
                    data: { tabTitle: 'Resultados', tabView: tabView, icon: 'icon-003' },
                    params: { q: params.q },
                    views: {}
                };
                state.views[uiView] = {
                    controller: 'SearchController',
                    controllerAs: 'vm',
                    templateUrl: 'app/views/flota/search/default.html',
                };
                var stateName = 'flota.' + tabView + '.results';
                runtimeStates.addState(stateName, state);

                return stateName;
            },

            /* DEPRECATED */
            search: function (i) {
                var q = i.value;
                if (q.length > 0) {
                    $rootScope.searchManager.searchText = q;
                    $state.go('flota.search.results', {
                        q: $rootScope.searchManager.searchText
                    });
                    $rootScope.blurry = false;
                    i.value = '';
                }
            },
            onEnterPressed: function (evt) {
                if (evt.which === 13) {
                    $rootScope.searchManager.search(evt.currentTarget);
                    $rootScope.searchManager.inputIsVisible = false;
                }
            },
            onSearchButtonClick: function (id) {
                var i = document.getElementById(id);
                if (!$rootScope.searchManager.inputIsVisible) {
                    $rootScope.searchManager.inputIsVisible = true;
                    setTimeout(function () {
                        i.focus();
                    }, 100);
                } else if ($rootScope.searchManager.inputIsVisible && i.value.length == 0) {
                    $rootScope.searchManager.inputIsVisible = false;
                } else if (i.value.length == 0) {
                    $rootScope.searchManager.search(i);
                    $rootScope.searchManager.inputIsVisible = false;
                } else {
                    $rootScope.searchManager.inputIsVisible = false;
                }
            },
            onSearchClear: function (id) {
                var i = document.getElementById(id);
                i.value = '';
                i.focus();
            }
            /* END DEPRECATED */
        };

        var searchTabsAccum = 0;
        var preloaded = false;
        $transitions.onBefore(
            /*jshint maxcomplexity:false */
            { to: function (state) { return state.data != null && state.data.tabTitle != null; } },
            function (transition) {
                var toState = transition.$to();
                var fromState = transition.$from();
                var params = transition.params();

                if (toState && toState.data) {
                    var index = $rootScope.tabManager.indexOfName(toState.data.tabView);
                    if (index > -1) {
                        var tab = $rootScope.tabManager.tabs[index];
                        if (tab.modified && !checkIsSameRoute(toState, params, tab)) {
                            tab.closeAction = function () {
                                $state.go(toState.name, params);
                            };
                            $rootScope.$broadcast('checkExitAction' + tab.state);
                            return false;
                        }
                    }
                }

                if (toState.name === 'login') {
                    return true;
                }

                if (toState.name !== 'login' && !authorization.hasToken()) {
                    return transition.router.stateService.target('login',
                        { redirectState: toState.name, redirectParams: params });
                }

                if (!authorization.hasLoaded) {
                    return transition.router.stateService.target('login',
                        { redirectState: toState.name, redirectParams: params, loading: true }, { location: false });
                }

                if (!preloaded) {
                    preloadStates(toState, params);
                    return false;
                }

                if (fromState && fromState.data) { $rootScope.$broadcast('tab-closed-' + fromState.data.tabView); }
                if (toState && toState.data) { $rootScope.$broadcast('tab-opened-' + toState.data.tabView); }

                if ($rootScope.tabManager.selectedTab) {
                    $rootScope.tabManager.selectedTab.sidebar = $rootScope.sidebarOpen;
                }

                var tabTitle = toState.data.tabTitle;
                var tabView = toState.data.tabView;
                var name = toState.name;
                if (toState.name === 'flota.search.results') {
                    searchTabsAccum++;
                    var uiView = 'searchContainer' + searchTabsAccum;
                    var tabView = 'search' + searchTabsAccum;
                    tabTitle += ' de "' + params.q + '"';

                    var stateName = $rootScope.searchManager.openSearchResultTab(searchTabsAccum, uiView, tabView, tabTitle, params);
                    return transition.router.stateService.target(stateName, params);

                } else if (toState.name.lastIndexOf('.results') > 11) {
                    tabTitle += ' de "' + params.q + '"';
                }

                $rootScope
                    .tabManager
                    .activate(tabTitle,
                    tabView,
                    name,
                    toState.data.icon,
                    toState.data.fixed === true,
                    params,
                    fromState,
                    toState.data.sidebar === true);

                $timeout(function () {
                    $rootScope.$broadcast('tab-opened');
                    $rootScope.$broadcast('detail-resize');
                }, 0);

            });

        function checkIsSameRoute(toState, params, tab) {
            if (toState.name !== tab.state) { return false; }
            for (var key in toState.params) {
                if (toState.params.hasOwnProperty(key)) {
                    if (toState.params[key].location === 1) {
                        if (tab.params[key] === undefined) { return false; }
                        if (tab.params[key] !== params[key]) { return false; }
                    }
                }
            }
            return true;
        }

        $rootScope.stateSelect = function (tab) {
            $state.go(tab.state, tab.params, tab.options);
        };

        // $rootScope.$on("$locationChangeStart", function (event, next, current) {
        //     var path = $location.path(); 
        //     for (let item of $rootScope.restrictionService.lectura) {
        //         if (path.search(item) != -1) {
        //             $location.path('/404');
        //             break;
        //         }


        //     }

        // });

        function preloadStates(finalState, finalParams) {
            preloaded = true;
            var openStates = $state.get().filter(function (state) { // Get states configured as 'open'
                if (state.data) { return state.data.open === true && state.name !== finalState.name; }
                return false;
            });

            //Preload the open states
            openStates
                // Create a promise chain that goes to one state, then goes to the next one...
                .reduce(function (memo, state) {

                    //Turn watchers off in the next digest cycle
                    $timeout(function () {
                        if (state && state.data) { $rootScope.$broadcast('tab-closed-' + state.data.tabView); }
                    }, 0);

                    // Dont update the location (location: false)
                    return memo.then(function () { return $state.go(state, undefined, { location: false }); });
                }, $q.when())
                .then(function () {
                    // Now sync the url
                    //$urlRouter.listen();
                    $state.go(finalState.name, finalParams);
                    $timeout(function () {
                        if (finalState && finalState.data) {
                            $rootScope.$broadcast('tab-opened-' + finalState.data.tabView);
                        }
                    }, 0);
                });
        }
    }
})();